import { Checkbox, Input, InputWrapperProps, TextInput, TextInputProps } from "@mantine/core";
import { useFormHelperContext } from "../form";
import { InputWrapper } from "../inputWrapper";
import { useEffect, useState } from "react";
import { useFormState } from "react-hook-form";
import "./checkboxGroup.css"
export interface CheckboxGroupItem {
    value: string;
    label: string;
}

export interface FieldInputCheckboxGroupProps
    extends InputWrapperProps {
    inputWrapper?: InputWrapperProps;
    label: string;
    error?: string;
    name: string
    readOnly?: boolean;
    checkboxItems: CheckboxGroupItem[]
}

const HORIZONTAL_FORM_CLASSES_INPUT = {
    root: "flex-grow"
}



export const FieldInputCheckboxGroup: React.FC<FieldInputCheckboxGroupProps> = ({ label, name, inputWrapper, readOnly, checkboxItems, ...rest }) => {
    const { register, formState, formStore, control, setValue, getValues } = useFormHelperContext()
    const value = getValues(name)
    if (!register) {
        throw new Error("Field.CheckboxGroup must be used within a FormHelper component");
    }

    const [currentValue, setCurrentValue] = useState<string[]>(value || [])
    useEffect(() => {
        setValue(name, currentValue)
    }, [currentValue])

    return (
        <InputWrapper label={label} {...inputWrapper} withAsterisk={rest.withAsterisk}>
            {/* <Checkbox
                readOnly={readOnly ?? formStore.readOnly}
                label={label}
                error={typeof formState.errors[name]?.message === 'string' ? formState.errors[name]?.message : undefined}
                classNames={formStore.horizontalForm ? HORIZONTAL_FORM_CLASSES_INPUT : undefined}
                {...register(name)}
            /> */}

            <Checkbox.Group

                data-testid={'field-checkbox-group-' + name}
                onChange={(values) => setCurrentValue(values)} value={currentValue} classNames={{
                    root: 'root-flex-custom'
                }}>
                {checkboxItems.map(item => (
                    <Checkbox key={item.value + item.label} value={item.value} label={item.label} disabled={readOnly} data-testid={'field-checkbox-group-' + name + '-item-' + item.value.replaceAll(' ', '')} />
                ))}
            </Checkbox.Group>

        </InputWrapper>

    );
}
